import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { NetworkTagsComponent } from '@app/features/merakis/modules/network-tags/pages/network-tags.component';
import { Authority } from '@app/shared/utils/enums';

export const networkTagsRoutes: Routes = [
    {
        path: 'network-tags',
        children: [
            {
                path: '',
                component: NetworkTagsComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.RESTAURANT_VIEW]
                }
                //,canActivate: [RouteAccessGuard]
            }
        ]
    }
]